import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useState, memo } from 'react';
import { TextField, Box, MenuItem, Typography, Grid, Popover, } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { appStyles } from '../App.styles';
import { aiModels } from '../constants';
/** Local styles */
const styles = {
    container: {
        width: '100%',
        padding: '0 0 1.5rem',
    },
    text: {
        width: '100%',
        fontWeight: '400',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '0.03125rem',
        color: '#191C1B',
        textAlign: 'left',
        alignItems: 'left',
        borderColor: '#707973',
    },
};
const PopoverSG = memo(function ({ aiModelMetadata, open, popoverAnchorEl, handlePopoverClose }) {
    const { t } = useTranslation();
    return (_jsx(Popover, Object.assign({ id: "mouse-over-popover", sx: {
            pointerEvents: 'none',
            borderRadius: '16px',
            '& .MuiPopover-paper': {
                borderRadius: '16px',
            }
        }, open: open, anchorEl: popoverAnchorEl, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, onClose: handlePopoverClose, disableRestoreFocus: true }, { children: _jsx(Box, Object.assign({ sx: {
                maxWidth: '240px',
                width: '100%',
                padding: '1rem',
                backgroundColor: 'white.main',
                borderRadius: '1rem!important',
            } }, { children: _jsxs(Grid, Object.assign({ container: true, rowSpacing: 1 }, { children: [_jsxs(Grid, Object.assign({ item: true, xs: 12, container: true, columnSpacing: 1, sx: {
                            width: '100%',
                            alignItems: 'center',
                            flexWrap: 'nowrap',
                            justifyContent: 'flex-start',
                        } }, { children: [_jsx(Grid, Object.assign({ item: true, sx: { display: 'flex', alignItems: 'center' } }, { children: _jsx(Box, { component: aiModelMetadata.Icon }) })), _jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(Typography, Object.assign({ variant: 'h1', sx: Object.assign(Object.assign({}, appStyles.text14), { lineHeight: '14px', fontWeight: '500', color: 'greenDarker.main', textAlign: 'left' }) }, { children: aiModelMetadata.aiProviderName })) }))] })), _jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(Typography, Object.assign({ variant: 'h1', sx: Object.assign(Object.assign({}, appStyles.text16), { width: '100%', fontWeight: '500', color: 'blackDark.main' }) }, { children: t(aiModelMetadata.title) })) })), _jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(Typography, Object.assign({ variant: 'text14', sx: { width: '100%', color: 'blackDark.main' } }, { children: t(aiModelMetadata.subtitle) })) })), _jsxs(Grid, Object.assign({ item: true, xs: 12, container: true, sx: {
                            margin: '0.5rem 0 0',
                            padding: '0.5rem 1rem',
                            border: '1px solid',
                            borderColor: 'greyLight.main',
                            borderRadius: '0.5rem',
                            backgroundColor: 'whiteDark.main',
                        } }, { children: [_jsxs(Grid, Object.assign({ item: true, xs: 6, container: true }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text16), { fontWeight: '500', color: 'blackDark.main' }) }, { children: aiModelMetadata.quality })) })), _jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text14), { fontWeight: '500', color: 'blackDark.main' }) }, { children: t('Quality') })) }))] })), _jsxs(Grid, Object.assign({ item: true, container: true, xs: 6 }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text16), { fontWeight: '500', color: 'blackDark.main' }) }, { children: aiModelMetadata.speed })) })), _jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text14), { fontWeight: '500', color: 'blackDark.main' }) }, { children: t('Speed') })) }))] }))] }))] })) })) })));
});
;
/**
 * Customized Select
 * @param {any} props
 * @returns {<Box>}
 */
export const AIModelSelectSG = function (props) {
    const { t } = useTranslation();
    const { items, label, hidden, xstyles, disableUnderline, isShowPopover, } = props;
    const outerStyles = xstyles || {};
    const [aiModelMetadata, setAIModelMetadata] = useState(aiModels[0]);
    const [
    /** Popover anchor */ popoverAnchorEl, setPopoverAnchorEl] = useState(null);
    /**
     * Handle popover open
     */
    const handlePopoverOpen = (event, idx) => {
        // Update AiI model metadata
        setAIModelMetadata(aiModels[idx]);
        // Update Popover anchor
        setPopoverAnchorEl(event.currentTarget);
    };
    /**
     * Handle Popover close
     */
    const handlePopoverClose = () => {
        setPopoverAnchorEl(null);
    };
    const [
    /** Select Open/close status */ selectOpen, setSelectOpen,] = useState(false);
    const open = selectOpen && (isShowPopover === true) && Boolean(popoverAnchorEl);
    return (_jsxs(Box, Object.assign({ sx: Object.assign(Object.assign(Object.assign(Object.assign({}, styles.container), { display: hidden ? 'none' : 'block' }), outerStyles), { borderRadius: '16px!important' }) }, { children: [_jsx(TextField
            // Customized select
            , Object.assign({ 
                // Customized select
                color: "primary" }, props, { label: t(label), select: true, sx: Object.assign(Object.assign({}, styles.text), { '& .MuiInput-input:focus': { backgroundColor: 'transparent' }, '& .MuiInputBase-root div.MuiSelect-select': {
                        backgroundColor: 'white.main',
                    } }), InputProps: {
                    disableUnderline: Boolean(disableUnderline),
                    //disableFocus: true,
                }, onFocus: () => { setSelectOpen(true); }, onBlur: () => { setSelectOpen(false); } }, { children: items.map((item, idx) => {
                    if (typeof (item) === 'string') {
                        return (_jsx(MenuItem, Object.assign({ value: item }, { children: t(item) }), item));
                    }
                    else {
                        const /** Item Icon */ Icon = item === null || item === void 0 ? void 0 : item.Icon;
                        return (_jsxs(MenuItem, Object.assign({ value: item === null || item === void 0 ? void 0 : item.value, sx: {
                                display: 'block',
                            }, disabled: ((item === null || item === void 0 ? void 0 : item.isReleased) === false) ? true : false, "aria-owns": open ? 'mouse-over-popover' : undefined, "aria-haspopup": "true", onMouseEnter: (e) => { handlePopoverOpen(e, idx); }, onMouseLeave: handlePopoverClose }, { children: [_jsxs(Grid, Object.assign({ container: true, sx: {
                                        width: '100%',
                                        overflow: 'hidden',
                                        flexWrap: 'nowrap',
                                        alignItems: 'center',
                                    } }, { children: [Icon ? _jsx(Box, { component: Icon, sx: { margin: '0 0.25rem 0 0' } }) : null, _jsx(Grid, Object.assign({ item: true }, { children: _jsx(Typography, Object.assign({ variant: 'h1', sx: Object.assign({}, appStyles.text16) }, { children: t(item === null || item === void 0 ? void 0 : item.title) })) })), _jsx(Grid, Object.assign({ item: true, sx: { display: ((item === null || item === void 0 ? void 0 : item.isProModel) === true || (item === null || item === void 0 ? void 0 : item.isReleased) === false) ? 'flex' : 'none' } }, { children: _jsxs(Grid, Object.assign({ container: true, sx: { flexWrap: 'nowrap' } }, { children: [_jsx(Grid, Object.assign({ item: true }, { children: "\u00A0" })), _jsx(Grid, Object.assign({ item: true }, { children: _jsx(Typography, Object.assign({ variant: 'text16', sx: {
                                                                fontWeight: 'bold',
                                                                color: 'blueLighter.main',
                                                            } }, { children: "\u00B7" })) })), _jsx(Grid, Object.assign({ item: true }, { children: "\u00A0" })), _jsx(Grid, Object.assign({ item: true }, { children: _jsx(Typography, Object.assign({ variant: 'text12', sx: {
                                                                color: 'blueLighter.main',
                                                                fontWeight: 'bold'
                                                            } }, { children: ((item === null || item === void 0 ? void 0 : item.isReleased) === false) ? t('UPCOMING') : ((item === null || item === void 0 ? void 0 : item.isProModel) === true ? (t(`PRO`)) : '') })) }))] })) }))] })), _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text12), { color: '#4B635A', display: 'none' }) }, { children: t(item === null || item === void 0 ? void 0 : item.subtitle) }))] }), item === null || item === void 0 ? void 0 : item.value));
                    }
                    ;
                }) })), _jsx(PopoverSG, { open: open, aiModelMetadata: aiModelMetadata, popoverAnchorEl: popoverAnchorEl, handlePopoverClose: handlePopoverClose })] })));
};
